module.exports = __webpack_public_path__ + "static/media/node.521444a2.png";